import 'whatwg-fetch';
import { Moment } from 'moment';
import { getClient } from './graphql';
import { RentalAdvertPricing, VerifiedAspect } from '../types/types';
import gql from 'graphql-tag';
import { HttpResult } from 'widgets-for-react';

type GraphqlResponse = {
  rentalAdvert: {
    pricing: RentalAdvertPricing
  }
}

type GraphqlVariables = {
  id: number
  start_date: string
  end_date: string
  max_people: number
  room_id: number
}

const query = () => gql`
  query Pricing($id:ID!,$start_date:ISO8601DateTime,$end_date:ISO8601DateTime,$max_people:Int,$room_id:Int) {
    rentalAdvert(id:$id) {
      pricing(startDate:$start_date, endDate:$end_date, maxPeople: $max_people, roomId: $room_id){
        price
        priceLabel
        error
        bookingLink
        bookLabel
        withBookingModule
        extraPricingDetails
      }
    }
  }
`

const normalizeForQuery = (date: Moment) : string => {
  if (!date) {
    return null;
  }

  return date.clone().startOf("day").add(8, "hours").toISOString();
}

export const fetchPricing = async (advert_id: number, start_date: Moment, end_date: Moment, max_people: number, room_id: number = null) : Promise<RentalAdvertPricing> => {
  const result = await getClient().query<GraphqlResponse, GraphqlVariables> ({
    query: query(),
    variables: {
      id: advert_id,
      start_date: normalizeForQuery(start_date),
      end_date: normalizeForQuery(end_date),
      max_people: max_people,
      room_id: room_id
    }
  });

  return result.data.rentalAdvert.pricing
}

const verifiedAspectsQuery = (type: 'rentalAdvert' | 'saleAdvert') => gql`
  query VerifiedAspects($id:ID!) {
    advert: ${type}(id:$id) {
      user {
        verifiedAspects
      }
    }
  }
`

export const fetchVerifiedAspects = async (
  advert_id: number,
  type: 'rentalAdvert' | 'saleAdvert'
): Promise<HttpResult<VerifiedAspect[]>> => {
  const result = await getClient().query<
    {
      advert: {
        user: {
          verifiedAspects: VerifiedAspect[]
        }
      }
    },
    { id: number }
  >({
    query: verifiedAspectsQuery(type),
    variables: {
      id: advert_id
    }
  })

  return {
    kind: 'result',
    value: result.data.advert.user.verifiedAspects,
    status: 200
  }
}
